import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngStatusSelectorComponent } from './kng-status-selector.component';
import { KngStatusSelectorService } from './kng-status-selector.service';
import { FormsModule } from '@angular/forms';

@NgModule({
	declarations: [
		KngStatusSelectorComponent
	],
	imports: [ CommonModule, FormsModule ],
	exports: [
		KngStatusSelectorComponent
	],
	providers: [
		KngStatusSelectorService
	]
})
export class KngStatusSelectorModule {}
